import React, { useEffect } from "react";
import CyberMonday from "@/components/cyber-monday/CyberMonday";
import MetaComponent from "@/components/common/MetaComponent";
import { trackPageMount } from "@/utils/analytics";

const metadata = {
  title: "Hubzu | Cyber Monday",
};

const CyberMondayScreen = () => {
  useEffect(() => {
    trackPageMount({
      pageName: "cyber_monday_page",
      eventCategory: "Page Mount",
      eventSource: "Cyber Monday Landing",
    });
  }, []);
  return (
    <>
      <MetaComponent meta={metadata} />
      <CyberMonday />
    </>
  );
};

export default CyberMondayScreen;
